import { formatDistance } from 'date-fns';
const formatDate = (date) => {
  if (!date) {
    return {};
  }

  const dateObject = new Date(date);
  const lastRan = dateObject
    ? formatDistance(new Date(), new Date(dateObject))
        ?.replace(/\babout\s/i, '')
        ?.replace(/minute(s)?/g, 'min$1')
        ?.replace(/hour(s)?/g, 'hr$1')
    : '';
  let label = `Last used ${lastRan} ago`;
  label = label[0].toUpperCase() + label.slice(1);

  const longOptions = { month: 'long', day: 'numeric', year: 'numeric' };
  const newDate = new Date(dateObject);
  newDate.setDate(newDate.getDate() + 1);

  return { label, title: newDate.toLocaleDateString('en-US', longOptions) };
};

export default formatDate;
